import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import React from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { handleError } from '../../../../shared/functions/handleError';
import { IHoliday } from '../../../../shared/interfaces/holiday/IHoliday';
import { AdminHolidaysService } from '../service';
import { holidaySchema } from './HolidayCreate';
import HolidayForm from './HolidayForm';

const HolidayUpdate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const { handleSubmit, control, watch } = useForm<IHoliday>({
    resolver: yupResolver(holidaySchema) as unknown as Resolver<IHoliday>,
    defaultValues: async () => {
      const response = await AdminHolidaysService.getSingle(Number(id));
      return response as IHoliday;
    },
  });

  const submitHandler = (formData: IHoliday) => {
    id &&
      AdminHolidaysService.update(formData, Number(id))
        .then((response) => {
          if (response) {
            navigate(-1);
            enqueueSnackbar(
              t('toasts.successfullyUpdated', { title: formData.name }),
              { variant: 'success' },
            );
          }
        })
        .catch((err) => handleError(err));
  };
  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <HolidayForm control={control} isUpdate watch={watch} />
    </form>
  );
};

export default HolidayUpdate;
